import { FC, useState, useRef } from 'react';
import { useFragment, graphql } from 'react-relay';

import VisibilityTracker from 'dibs-visibility-tracker/exports/VisibilityTracker';
import { NftDraftItemTileMedia } from './NftDraftItemTileMedia';
import { NftDraftItemTileDetails } from './NftDraftItemTileDetails';

import styles from '../../styles/NftItemTile.scss';

import { NftDraftItemTile_viewer$key } from './__generated__/NftDraftItemTile_viewer.graphql';
import { NftDraftItemTile_nftItemDraft$key } from './__generated__/NftDraftItemTile_nftItemDraft.graphql';

type Props = {
    viewer: NftDraftItemTile_viewer$key;
    nftItemDraft: NftDraftItemTile_nftItemDraft$key;
    fireImpressionTracking?: () => void;
};

export const NftDraftItemTile: FC<Props> = ({
    viewer: viewerRef,
    nftItemDraft: nftItemDraftRef,
    fireImpressionTracking = () => {},
}) => {
    const viewer = useFragment(
        graphql`
            fragment NftDraftItemTile_viewer on Viewer {
                ...NftDraftItemTileDetails_viewer
            }
        `,
        viewerRef
    );
    const nftItemDraft = useFragment(
        graphql`
            fragment NftDraftItemTile_nftItemDraft on NftItemDraft {
                serviceId
                name
                editionNumber
                editionTotal
                ...NftDraftItemTileMedia_nftItemDraft
                ...NftDraftItemTileDetails_nftItemDraft
            }
        `,
        nftItemDraftRef
    );

    const tileRef = useRef<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);

    return (
        <div ref={tileRef} className={styles.container}>
            <VisibilityTracker
                onVisibilityChange={({ isVisible }) => setVisible(isVisible)}
                elementRef={tileRef}
                watchAfterFirstVisible
            />
            <VisibilityTracker
                onVisibilityChange={({ isVisible, disconnect }) => {
                    if (isVisible) {
                        disconnect();
                        fireImpressionTracking();
                    }
                }}
                elementRef={tileRef}
            />

            <NftDraftItemTileMedia animate={visible} nftItemDraft={nftItemDraft} />

            <NftDraftItemTileDetails viewer={viewer} nftItemDraft={nftItemDraft} />
        </div>
    );
};
